"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CardinalDirections = void 0;
var CardinalDirections;
(function (CardinalDirections) {
    CardinalDirections["North"] = "NORTH";
    CardinalDirections["East"] = "EAST";
    CardinalDirections["South"] = "SOUTH";
    CardinalDirections["West"] = "WEST";
})(CardinalDirections = exports.CardinalDirections || (exports.CardinalDirections = {}));
class AntBoard {
    constructor(board) {
        this.turns = 0;
        this.foodGathered = 0;
        this.currentBoard = [];
        this.baseBoard = board;
        this.antDirection = CardinalDirections.East;
        this.antPosition = [0, 0];
        this.reset();
    }
    get width() {
        return this.baseBoard[0].length;
    }
    get height() {
        return this.baseBoard.length;
    }
    getBoardValue(...pos) {
        return this.currentBoard[pos[0]][pos[1]];
    }
    setBoardValue(pos, value) {
        this.currentBoard[pos[0]][pos[1]] = value;
    }
    reset() {
        // Reset food:
        this.foodGathered = 0;
        this.turns = 0;
        // Reset board:
        for (let row = 0; row < this.height; row++) {
            this.currentBoard[row] = [];
            for (let col = 0; col < this.width; col++) {
                this.setBoardValue([row, col], this.baseBoard[row][col]);
            }
        }
        // Reset ant:
        this.antPosition = [0, 0];
        this.antDirection = CardinalDirections.East;
        return this;
    }
    positionInFrontOfAnt() {
        const rePos = [this.antPosition[0], this.antPosition[1]];
        // What way are we facing?
        switch (this.antDirection) {
            case CardinalDirections.East:
                rePos[1] += 1;
                break;
            case CardinalDirections.West:
                rePos[1] -= 1;
                break;
            case CardinalDirections.North:
                rePos[0] -= 1;
                break;
            case CardinalDirections.South:
                rePos[0] += 1;
        }
        // Handle wrap around:
        if (rePos[0] < 0) {
            rePos[0] += this.height;
        }
        else if (rePos[0] >= this.height) {
            rePos[0] -= this.height;
        }
        if (rePos[1] < 0) {
            rePos[1] += this.width;
        }
        else if (rePos[1] >= this.width) {
            rePos[1] -= this.width;
        }
        return rePos;
    }
    // Returns [t,f] if location ahead is food, else [f,t]
    getState() {
        const pos = this.positionInFrontOfAnt();
        const foodAtPos = this.getBoardValue(...pos);
        return [foodAtPos, !foodAtPos];
    }
    executeAction(left, right) {
        if (left && right) {
            // [t,t] is forward
            this._moveForward();
        }
        else if (left) {
            // [t,f] is left
            this.antDirection = this.getTurnDirection(this.antDirection, false);
        }
        else if (right) {
            // [f,t] is right
            this.antDirection = this.getTurnDirection(this.antDirection, true);
        }
        // [f,f] is nothing
        this.turns += 1;
        return this;
    }
    _moveForward() {
        const pos = this.positionInFrontOfAnt();
        this.antPosition = pos;
        // Is there food?
        if (this.getBoardValue(...this.antPosition)) {
            this.foodGathered += 1;
            this.setBoardValue(this.antPosition, false);
        }
    }
    getTurnDirection(startDirection, clockwise) {
        switch (startDirection) {
            case CardinalDirections.East:
                return clockwise ? CardinalDirections.South : CardinalDirections.North;
            case CardinalDirections.South:
                return clockwise ? CardinalDirections.West : CardinalDirections.East;
            case CardinalDirections.West:
                return clockwise ? CardinalDirections.North : CardinalDirections.South;
            case CardinalDirections.North:
                return clockwise ? CardinalDirections.East : CardinalDirections.West;
        }
    }
}
exports.default = AntBoard;
